import styles from './PageLoader.module.scss'

export function PageLoader() {
  return (
    <div className={styles.loader} role="status" aria-live="polite">
      <span className={styles.dot} />
      Loading board...
    </div>
  )
}

